module.exports = JSON.parse('{"No results.":"No results.","Not enough room to display this column":"Not enough room to display this column"}')